import { memo, useEffect, useState } from "react";
import { Gift, X } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { claimDailyVisitBonus, getDailyVisitBonusState, recordDailyVisitProgress } from "@/lib/demoStore";
import { getAuthState } from "@/lib/authSession";

const DailyVisitBonus = () => {
  const auth = getAuthState();
  const [state, setState] = useState(() => getDailyVisitBonusState(auth.user));
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!auth.loggedIn || !auth.user) return;

    let lastTick = Date.now();
    setState(getDailyVisitBonusState(auth.user));

    const timer = window.setInterval(() => {
      if (document.visibilityState !== "visible") {
        lastTick = Date.now();
        return;
      }

      const now = Date.now();
      const next = recordDailyVisitProgress(auth.user, now - lastTick);
      lastTick = now;
      setState(next);

      if (next.claimable) {
        setVisible(true);
      }
    }, 60000);

    return () => window.clearInterval(timer);
  }, [auth.loggedIn, auth.user]);

  if (!auth.loggedIn || !state.enabled || !visible || !state.claimable) {
    return null;
  }

  return (
    <div className="fixed bottom-24 right-4 z-50 w-full max-w-sm rounded-2xl border bg-card p-4 shadow-2xl md:bottom-6">
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="flex items-center gap-2 font-semibold text-foreground"><Gift size={16} className="text-primary" />Daily visit reward ready</p>
          <p className="mt-1 text-sm text-muted-foreground">You unlocked ₦{state.rewardAmount.toLocaleString()} advert wallet value after your cumulative active visit time.</p>
        </div>
        <button type="button" className="text-muted-foreground" onClick={() => setVisible(false)} aria-label="Close reward popup">
          <X size={16} />
        </button>
      </div>
      <div className="mt-3 flex gap-2">
        <Button size="sm" onClick={() => {
          const result = claimDailyVisitBonus(auth.user);
          if (!result.ok) {
            toast.error(result.error || "Daily bonus is no longer available.");
            setVisible(false);
            return;
          }

          setState(getDailyVisitBonusState(auth.user));
          setVisible(false);
          toast.success("Daily visit bonus claimed.");
        }}>Claim reward</Button>
        <Button size="sm" variant="outline" onClick={() => setVisible(false)}>Later</Button>
      </div>
    </div>
  );
};

export default memo(DailyVisitBonus);
